import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { AgentTaskAssigneeSchema, AgentTaskStatus } from "./agent-tasks";

export enum AgentTaskEventKind {
  VERIFICATION = "verification",
  STATUS_UPDATE = "status_update",
  ASSIGNEE_UPDATE = "assignee_update",
}

export enum AgentTaskEventActorKind {
  USER = "user",
  SYSTEM = "system",
}

export enum AgentTaskVerificationStatus {
  COMPLETE = "complete",
  INCOMPLETE = "incomplete",
}

const agentTaskEventActorSchema_ = z.object({
  kind: createEnum(AgentTaskEventActorKind, {
    enumName: "agent_task_event_actor_kind",
  }),
  identifier: z.string().optional(),
});
export const AgentTaskEventActorSchema: z.ZodType<AgentTaskEventActor> =
  agentTaskEventActorSchema_;
export interface AgentTaskEventActor
  extends z.infer<typeof agentTaskEventActorSchema_> {}

const agentTaskVerificationResultSchema_ = z.object({
  status: createEnum(AgentTaskVerificationStatus, {
    enumName: "agent_task_verification_status",
  }),
  feedback: z.string().optional(),
});
export const AgentTaskVerificationResultSchema: z.ZodType<AgentTaskVerificationResult> =
  agentTaskVerificationResultSchema_;
export interface AgentTaskVerificationResult
  extends z.infer<typeof agentTaskVerificationResultSchema_> {}

const agentTaskStatusUpdateSchema_ = z.object({
  previousStatus: createEnum(AgentTaskStatus, {
    enumName: "agent_task_status",
  }),
  newStatus: createEnum(AgentTaskStatus, { enumName: "agent_task_status" }),
});
export const AgentTaskStatusUpdateSchema: z.ZodType<AgentTaskStatusUpdate> =
  agentTaskStatusUpdateSchema_;
export interface AgentTaskStatusUpdate
  extends z.infer<typeof agentTaskStatusUpdateSchema_> {}

const agentTaskAssigneeUpdateSchema_ = z.object({
  previousAssignee: AgentTaskAssigneeSchema.optional(),
  newAssignee: AgentTaskAssigneeSchema.optional(),
});
export const AgentTaskAssigneeUpdateSchema: z.ZodType<AgentTaskAssigneeUpdate> =
  agentTaskAssigneeUpdateSchema_;
export interface AgentTaskAssigneeUpdate
  extends z.infer<typeof agentTaskAssigneeUpdateSchema_> {}

const agentTaskEventSchema_ = z.object({
  _id: zExt.objectId(),
  taskId: zExt.objectId(),
  timestamp: z.date(),
  actor: agentTaskEventActorSchema_,
  kind: createEnum(AgentTaskEventKind, { enumName: "agent_task_event_kind" }),
  verificationResult: agentTaskVerificationResultSchema_.optional(),
  statusUpdate: agentTaskStatusUpdateSchema_.optional(),
  assigneeUpdate: agentTaskAssigneeUpdateSchema_.optional(),
});

export const AgentTaskEventSchema: z.ZodType<AgentTaskEvent> =
  agentTaskEventSchema_;
export interface AgentTaskEvent extends z.infer<typeof agentTaskEventSchema_> {}
